module.exports = __webpack_public_path__ + "img/34.f7c50f12.svg";